





























import { Component, Vue, Mixins, Watch } from "vue-property-decorator";
// 组件
import Header from "./components/Header.vue";
import Table from "./components/Table.vue";
// 混入
import Loading from "@/mixins/loading";
// 工具
import debounce from "@/utils/debounce";

@Component({
  components: {
    Table,
    Header,
  },
})
export default class Vip extends Mixins(Loading) {
  cardType:string = '';//身份类型（逗号分开） 查询列表
  fromDate: string = ""; // 注册开始日期
  shopName: string = ""; // 企业名称
  phone: string = ""; // 手机号码
  userName: string = ""; // 客户名称
  recentExpenseBeginTime: string = ""; //最近的消费开始时间
  operationMemberId: number|null = null;
  serviceId: number|null = null;
  subCompanyId: number|null = null;




  // 搜索
  handleSearch() {
    let table: any = this.$refs.table;
    table.getData();
  }
  // 输入
  inputValue(val: string, type: string) {
    let self: any = this;
    self[type] = val;
  }
}
